import { components, operations } from "types/openapi";
import { ENDPOINTS } from "./endpoints";
import { api } from "./api";

export type OfferFieldType = components["schemas"]["OfferFieldDto"];
type uploadFile = operations["uploadOffer"];

export const getOfferFieldCodes = async (): Promise<OfferFieldType[]> => {
  return api.get(ENDPOINTS.getOfferDocCodes());
};

export const downloadOfferDocFile = async (): Promise<Blob> => {
  return api.get(ENDPOINTS.companyOfferFile());
};

export const uploadOfferDoc = ({
  formData,
}: {
  formData: FormData;
}): Promise<uploadFile["responses"]["200"]["content"]["*/*"]> => {
  return api.post(ENDPOINTS.uploadOfferTemplate(), formData);
};
